import { createContext, Context } from 'react';

const AlertTaskContext: Context<any> = createContext(null);

export default AlertTaskContext;
